import { useQuery, gql } from "@apollo/client"

const IDENTITYPROVIDER_FIELDS = `
  id
  unique
  name
  client
  authority
  browserPrompt
  devicePrompt
  createdAt
`

const IDENTITYPROVIDER_QUERY = gql`
  query {
    identityProviders {
      ${IDENTITYPROVIDER_FIELDS}
    }
  }
`

const useQueryIdentityProviders = () => useQuery(IDENTITYPROVIDER_QUERY)

export { useQueryIdentityProviders, IDENTITYPROVIDER_FIELDS }
